import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  FaCheck,
  FaCoins,
  FaDiscord,
  FaMedium,
  FaSquareXTwitter,
  FaTelegram,
  FaYoutube,
} from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import TwitterLogin from "react-twitter-login";

import { BASE_URL, CDN_BASE_URL } from "../../config";
import { getUser } from "../../api/getUser";
import Loading from "../common/Loading";
import MediumModal from "../common/modals/MediumModal";
import TwitterModal from "../common/modals/TwitterModal";
import TwitterTask from "../tasks/TwitterTask";
import YoutubeTask from "../tasks/YoutubeTask";
import TelegramTask from "../tasks/TelegramTask";
import DiscordTask from "../tasks/DiscordTask";
import WatchVideoTask from "../tasks/WatchVideoTask";
import { httpReauest } from "../../utils/httpRequest";
import ArticaleTask from "../tasks/ArticaleTask";
import DiscordNameTask from "../tasks/DiscordNameTask";
import PostTwitterTask from "../tasks/PostTwitterTask";
import PreSaleTask from "../tasks/PreSaleTask";
import YoutubeCommentTask from "../tasks/YoutubeCommentTask";
import ShareTask from "../tasks/ShareTask";
import InstagramTask from "../tasks/InstagramTask";
import LinkedinTask from "../tasks/LinkedinTask";
import MediumTask from "../tasks/MediumTask";
import RedditTask from "../tasks/RedditTask";
import GithubTask from "../tasks/GithubTask";
import StakingTask from "../tasks/StakingTask";

const UserTasks = ({ data }) => {
  const [user, setuser] = useState();
  const [tasks, settasks] = useState();
  const [showTwitter, setshowTwitter] = useState();
  const [loading, setloading] = useState(true);

  async function getData(params) {
    const user = JSON.parse(localStorage.getItem("user"));

    const res = await getUser(user?._id);
    const res2 = await httpReauest("GET", "/tasks", {}, {});
    settasks(res2?.data?.data);
    setuser(res);
    setloading(false);
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="rounded-[26px] bg-[#4A5A69] p-3 lg:p-6 flex justify-center flex-col items-center relative shadow shadow-white/40 border border-white/10">
      {showTwitter && (
        <>
          <div
            onClick={() => setshowTwitter(false)}
            className="w-full h-full z-40 bg-black/50 fixed top-0 left-0"
          ></div>
          <TwitterModal getData={getData} setShow={setshowTwitter} />
        </>
      )}
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="flex flex-col w-full gap-3">
            {tasks?.share && (
              <ShareTask
                user={user}
                reward={tasks?.shareReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.twitter && (
              <TwitterTask
                user={user}
                reward={tasks?.twitterReward}
                getData={getData}
                setuser={setuser}
              />
            )}{" "}
            {tasks?.staking && (
              <StakingTask
                user={user}
                reward={tasks?.stakingReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.github && (
              <GithubTask
                user={user}
                reward={tasks?.githubReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.reddit && (
              <RedditTask
                user={user}
                reward={tasks?.redditReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.medium && (
              <MediumTask
                user={user}
                reward={tasks?.mediumReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.linkedin && (
              <LinkedinTask
                user={user}
                reward={tasks?.linkedinReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.instagram && (
              <InstagramTask
                user={user}
                reward={tasks?.instagramReward}
                getData={getData}
                setuser={setuser}
              />
            )}
            {tasks?.youtube && (
              <YoutubeTask
                user={user}
                reward={tasks?.youtubeReward}
                setuser={setuser}
              />
            )}
            {tasks?.telegram && (
              <TelegramTask user={user} reward={tasks?.telegramReward} />
            )}
            {tasks?.discord && (
              <DiscordTask
                user={user}
                reward={tasks?.discordReward}
                setuser={setuser}
              />
            )}
            {tasks?.youtubeWatch && (
              <WatchVideoTask user={user} reward={tasks?.youtubeWatchReward} />
            )}
            {tasks?.discordname && (
              <DiscordNameTask
                user={user}
                reward={tasks?.discordnameReward}
                setuser={setuser}
              />
            )}
            {tasks?.youtubeComment && (
              <YoutubeCommentTask
                user={user}
                reward={tasks?.youtubeCommentReward}
                setuser={setuser}
              />
            )}
            {tasks?.articale && (
              <ArticaleTask
                user={user}
                reward={tasks?.articaleReward}
                getData={getData}
              />
            )}
            {tasks?.postAboutTwitter && (
              <PostTwitterTask
                user={user}
                reward={tasks?.postAboutTwitterReward}
                getData={getData}
              />
            )}
            {tasks?.presale && <PreSaleTask user={user} getData={getData} />}
          </div>
        </>
      )}
    </div>
  );
};

export default UserTasks;
